<template>
  <ResponsiveLayout :progress="progress">
    <template
      v-if="canGoBack"
      #header_start
    >
      <ButtonBack @click="navigateBack" />
    </template>
    <template #header_end><HeaderHelp /></template>

    <div class="kds-main-wrapper">
      <div class="kds-content-block">
        <p class="kds-typography-title-xlarge">
          {{ $t('eu__doctor_outreach_prescriber_search__title') }}
        </p>
        <p class="kds-typography-paragraph-large">
          {{ $t('eu__doctor_outreach_prescriber_search__description') }}
        </p>
      </div>

      <form
        id="doctor-practice-search-form"
        class="kds-content-block"
        @submit.prevent
      >
        <DoctorPracticePicker
          ref="pickerRef"
          :confirmed-practice-id="doctorOutreachStore.selectedPracticeId"
          data-qa="doctor-practice-search-field"
          :label="$t('eu__doctor_outreach_prescriber_search__label')"
          :search-fn="triggerPracticeSearch"
          :featured-fn="triggerEmptySearch"
          :search-error-title="$t('generic__error_title')"
          :search-error-description="$t('generic__try_again')"
          @confirm="persistSelection"
          @manual-entry="handleManualEntry"
        />
      </form>
    </div>

    <template #actions>
      <BaseButton
        type="submit"
        data-qa="doctor-practice-search-submit"
        :text="$t('generic_action_continue')"
        @click="handlePrimaryCtaClick"
      />
    </template>
  </ResponsiveLayout>
</template>

<script setup>
import { ref } from 'vue'
import useOnboardingProgress from '@eu/app/composables/useOnboardingProgress.js'
import useNavigation from '@eu/app/composables/useNavigation'
import ROUTE from '@eu/app/router/appModule/names'

import * as apiRequest from '@shared/api-endpoints'

import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import ButtonBack from '@shared/components/ButtonBack.vue'
import HeaderHelp from '@eu/app/components/HeaderHelp.vue'
import DoctorPracticePicker from '@eu/app/components/DoctorPracticePicker.vue'
import BaseButton from '@shared/components/BaseButton.vue'
import Tracker from '@shared/Tracker'
import useDoctorOutreachStore from '@eu/app/stores/useDoctorOutreachStore.js'
import useFeatureFlagStore from '@shared/stores/useFeatureFlagStore'

const { progress } = useOnboardingProgress()
const { navigateNext, navigateBack, canGoBack } = useNavigation(
  ROUTE.DOCTOR_OUTREACH_PRESCRIBER_SEARCH,
)
const doctorOutreachStore = useDoctorOutreachStore()
const featureFlagStore = useFeatureFlagStore()

const pickerRef = ref(null)

const triggerPracticeSearch = async (query, abortSignal) => {
  const result = await apiRequest.searchDoctorPractice(
    query,
    abortSignal,
    featureFlagStore.flags.doctorSearchUsingVzD,
  )
  return result?.data ?? []
}

const triggerEmptySearch = () => triggerPracticeSearch('')

const persistSelection = (practice) => {
  doctorOutreachStore.prescriberRequest = null
  doctorOutreachStore.selectedPracticeId = practice.id
}

const handlePrimaryCtaClick = () => {
  if (pickerRef.value.requirePractice() == null) return

  Tracker.trackButtonSelect('submit', 'doctor_outreach_prescriber_search')
  navigateNext('prescriberSelected')
}

const handleManualEntry = () => {
  navigateNext('manualEntry')
}
</script>
